var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "SelectListsOfFriends" },
    [
      !_vm.loaded ? _c("div", { staticClass: "spinner-border" }) : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c("vue-select", {
            attrs: {
              multiple: "",
              placeholder: "Select Connections List",
              options: _vm.friend_lists,
              label: "name",
              reduce: function(option) {
                return option.id
              },
              selectable: function(selected) {
                return !_vm.friends_group.includes(selected.id)
              },
              value: _vm.friends_group
            },
            on: {
              input: function($event) {
                return _vm.$emit("changed", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }